import { FunctionComponent } from "react"
import { ToastContainer } from "react-toastify"
import { toastDefaultProps } from "./constants/toast"
import "react-toastify/dist/ReactToastify.css"
import Providers from "./context/Providers"
import Router from "./pages/Router"
import ConfirmModal from "./components/ConfirmModal"
import { confirmModal } from "./constants/refs"

const App: FunctionComponent = () => {
  return (
    <Providers>
      <Router />

      <ToastContainer {...toastDefaultProps} />
      <ConfirmModal ref={confirmModal} />
    </Providers>
  )
}

export default App
